<template>
  <form @submit.prevent="timezoneAction" class="row">
    <div class="mb-3">
      <label>Name</label>
      <input
          v-model="timezone.timezoneName"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.timezone.timezoneName.$error,
          }"
      />
      <p
          v-for="error of v$.timezone.timezoneName.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3 col-6">
      <label>Start Time</label>
      <vue-timepicker format="HH:mm:ss" v-model="timezone.timezoneStartTime" class="time-picker-height-3" :class="{
                        'is-invalid': v$.timezone.timezoneStartTime.$error,
                  }"></vue-timepicker>
      <p
          v-for="error of v$.timezone.timezoneStartTime.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3 col-6">
      <label>End Time</label>
      <vue-timepicker format="HH:mm:ss" v-model="timezone.timezoneEndTime" class="time-picker-height-3" :class="{
                        'is-invalid': v$.timezone.timezoneEndTime.$error,
                  }"></vue-timepicker>
      <p
          v-for="error of v$.timezone.timezoneEndTime.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in SettingsErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-3 h3" disabled v-if="SettingsLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {mapGetters} from "vuex";

export default {
name: "timezone-form",
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      timezone: this.selected_zone,
    }
  },
  props: {
    selected_zone: {
      type: Object,
      default(){
        return{
          timezoneName: '',
          timezoneStartTime: '',
          timezoneEndTime: ''
        }
      }
    },
    button_text: {type: String}
  },
  computed: {
    ... mapGetters({
      SettingsLoading: 'settings/settingsLoading',
      SettingsErrors: 'settings/settingsErrors'
    }),
  },
  validations () {
    return {
      timezone: {
        timezoneName: {required},
        timezoneStartTime: {required},
        timezoneEndTime: {required}
      }
    }
  },
  methods: {
    async timezoneAction(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      this.$emit('timezoneAction', this.timezone)
      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
